<template>
    <span>{{value}}</span>
</template>

<script>
    export default {
        name: "AExtBoldA",
        props:{
            value:{
                type:String,
                default:''
            }
        }
    }
</script>

<style scoped>

</style>